import React, { useEffect, useState } from 'react';
import SimpleBarChart from './charts/SimpleBarChart';

function MonthlyConsumptionChart({ type, start, end, isCustom = false }) {
  const [stats, setStats] = useState({ selected: 0, previous: 0 });

  useEffect(() => {
    if (!start || !end) return;
    const startSelected = new Date(start);
    const endSelected = new Date(end);
    const fmt = d => d.toISOString().slice(0, 10);

    if (isCustom) {
      fetch(
        `/api/consumption-stats-range.php?start=${fmt(startSelected)}&end=${fmt(endSelected)}`
      )
        .then(r => r.json())
        .then(selRes => {
          const selAvg =
            type === 'magnetite'
              ? selRes.magnetite_consumption || 0
              : selRes.flocculant_consumption || 0;
          setStats({ selected: selAvg, previous: 0 });
        })
        .catch(() => setStats({ selected: 0, previous: 0 }));
    } else {
      const prevStart = new Date(
        startSelected.getFullYear(),
        startSelected.getMonth() - 1,
        1
      );
      const prevEnd = new Date(
        startSelected.getFullYear(),
        startSelected.getMonth(),
        0
      );
      Promise.all([
        fetch(
          `/api/consumption-stats-range.php?start=${fmt(prevStart)}&end=${fmt(prevEnd)}`
        ).then(r => r.json()),
        fetch(
          `/api/consumption-stats-range.php?start=${fmt(startSelected)}&end=${fmt(endSelected)}`
        ).then(r => r.json()),
      ])
        .then(([prevRes, selRes]) => {
          const selAvg =
            type === 'magnetite'
              ? selRes.magnetite_consumption || 0
              : selRes.flocculant_consumption || 0;
          const prevAvg =
            type === 'magnetite'
              ? prevRes.magnetite_consumption || 0
              : prevRes.flocculant_consumption || 0;
          setStats({ selected: selAvg, previous: prevAvg });
        })
        .catch(() => setStats({ selected: 0, previous: 0 }));
    }
  }, [type, start, end, isCustom]);

  const calcStep = val => {
    if (val === 0) return 1;
    const rough = val / 5;
    const pow = Math.pow(10, Math.floor(Math.log10(rough)));
    const mults = [1, 2, 5, 10];
    for (const m of mults) {
      if (rough <= m * pow) return m * pow;
    }
    return 10 * pow;
  };

  const target = type === 'magnetite' ? 0.5 : 10;
  const maxVal = Math.max(
    stats.selected,
    isCustom ? target : Math.max(stats.previous, target)
  );
  const step = calcStep(maxVal);
  const tickCount = Math.ceil(maxVal / step);
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => +(i * step).toFixed(2));
  const maxAxis = tickCount > 0 ? ticks[ticks.length - 1] : step;

  return (
    <SimpleBarChart
      height={160}
      data={
        isCustom
          ? [
              {
                label: 'Custom date',
                value: stats.selected,
                color: '#22c55e',
                display: stats.selected.toFixed(2),
                valueInside: true,
              },
              {
                label: 'Target',
                value: target,
                color: '#3b82f6',
                display: target.toString(),
                valueInside: true,
              },
            ]
          : [
              {
                label: 'Selected Month',
                value: stats.selected,
                color: '#22c55e',
                display: stats.selected.toFixed(2),
                valueInside: true,
              },
              {
                label: 'Previous Month',
                value: stats.previous,
                color: '#22c55e',
                display: stats.previous.toFixed(2),
                valueInside: true,
              },
              {
                label: 'Target',
                value: target,
                color: '#3b82f6',
                display: target.toString(),
                valueInside: true,
              },
            ]
      }
      max={maxAxis}
      ticks={ticks}
      valueClass="text-sm font-bold"
      labelFontSize={14}
      labelBold
    />
  );
}

export default MonthlyConsumptionChart;
